import type { OnyxComponentInputs, OnyxTableColumn } from '@onyx/angular';
import { BadgesCellComponent } from '../../../../../common/components/cells/badges-cell/badges-cell.component';
import { StringCellComponent } from '../../../../../common/components/cells/string-cell/string-cell.component';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import type { ContractorType } from '../../../contractors/common/enums/contractor-type';
import type { PointOfInterestAssignedContractorsFormGroup } from '../../point-of-interest-form/point-of-interest-assigned-contractors-form/point-of-interest-assigned-contractors-form.component';
import { PointsOfInterestContractorCellComponent } from '../cells/points-of-interest-contractor-cell/points-of-interest-contractor-cell.component';
import { PointsOfInterestGateCellComponent } from '../cells/points-of-interest-gate-cell/points-of-interest-gate-cell.component';

export const ASSIGNED_CONTRACTORS_COLUMNS: OnyxTableColumn<PointOfInterestAssignedContractorsFormGroup>[] =
  [
    {
      id: 'contractor',
      name: 'labels.contractor',
      width: 'fill',
      component: {
        ref: PointsOfInterestContractorCellComponent,
        inputs: (
          data,
        ): OnyxComponentInputs<PointsOfInterestContractorCellComponent> => ({
          contractor: data.item.controls.contractor.getRawValue(),
        }),
      },
    },
    {
      id: 'nipNumber',
      name: 'labels.vatId',
      width: '110px',
      component: {
        ref: StringCellComponent,
        inputs: (data): OnyxComponentInputs<StringCellComponent> => ({
          value: `${data.item.getRawValue().contractor.companyProfile.country.toUpperCase()} ${data.item.getRawValue().contractor.companyProfile.vatId}`,
        }),
      },
    },
    {
      id: 'contractorType',
      name: 'labels.contractorType',
      width: '150px',
      component: {
        ref: BadgesCellComponent,
        inputs: (
          data,
        ): OnyxComponentInputs<BadgesCellComponent<ContractorType>> => ({
          badges: data.item.getRawValue().contractor.companyProfile.types,
          dictionaryCode: DictionaryCode.CONTRACTOR_TYPE,
        }),
      },
    },
    {
      id: 'gate',
      name: 'labels.gate',
      width: '100px',
      component: {
        ref: PointsOfInterestGateCellComponent,
        inputs: (
          data,
        ): OnyxComponentInputs<PointsOfInterestGateCellComponent> => ({
          gate: data.item.controls.gate,
        }),
      },
    },
  ];
